import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';

/**
 * Fallback page for /ricerca — redirects to home.
 * Search is now handled by the SearchOverlay in the header.
 */
const RicercaPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <Layout>
      <section className="section">
        <div className="container" style={{ textAlign: 'center' }}>
          <p>Reindirizzamento...</p>
        </div>
      </section>
    </Layout>
  );
};

export default RicercaPage;
